import styled from 'styled-components';

export const Row = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
`;

export const Star = styled.button<{
  $active: boolean;
  $reducedMotion: boolean;
}>`
  --tap: 4.4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--tap);
  height: var(--tap);
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 2.8rem;
  line-height: 1;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.amber : theme.colors.borderStrong};
  transition: ${({ $reducedMotion }) =>
    $reducedMotion ? 'none' : 'color 0.15s ease, transform 0.15s ease'};

  &:hover,
  &:focus-visible {
    transform: ${({ $reducedMotion }) =>
      $reducedMotion ? 'none' : 'scale(1.08)'};
  }

  &:focus-visible {
    outline: 0.2rem solid ${({ theme }) => theme.colors.accent};
    outline-offset: 0.2rem;
    border-radius: 0.6rem;
  }

  &:disabled {
    cursor: default;
  }
`;
